import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { decorateUser } from "./_helpers";

export const user_self: Query<Ctx> = async ({ sb }, _params) => {
  const { data: sessionData, error } = await sb.auth.getSession();
  const userId = sessionData.session?.user?.id;
  if (!userId) {
    console.error(error);
    return null;
  }

  const { data } = await sb
    .from("v_users_list")
    .select("*")
    .eq("id", userId)
    .single();
  if (!data) return null;
  return decorateUser(data);
};
